import React, { useEffect, useRef, useState } from "react"
import Grid from "components/grid"
import useIntersectionObserver from "../hooks/use-intersection-observer"

const DyptiqueSlideshow = ({ className, slides }) => {
  const parentEl = useRef()
  const timeout = useRef()
  const [currentSlide, setCurrentSlide] = useState(1)
  const playSlide = () => {
    timeout.current = setTimeout(() => {
      const nextIndex = currentSlide + 2
      const currentIndex = nextIndex > slides.length ? 1 : nextIndex
      setCurrentSlide(currentIndex)
    }, 1000)
  }
  useEffect(() => {
    playSlide()
  }, [])
  useIntersectionObserver({
    target: parentEl,
    rootMargin: `0px 0px 0px 0px`,
    threshold: 0,
    onIntersect: ([{ isIntersecting }]) => {
      if (isIntersecting) {
        playSlide()
      } else {
        clearTimeout(timeout.current)
      }
    }
  })
  return (
    <div ref={parentEl}>
      <Grid className={`${className}`}>
        <div className={`col-span-6`}>
          { slides[currentSlide - 1] }
        </div>
        <div className={`col-span-6`}>
          { slides[currentSlide] }
        </div>
      </Grid>
    </div>
  )
}

export default DyptiqueSlideshow